import { array, literal, nativeEnum, object, string, TypeOf, union } from 'zod';

import { Alignment, Link } from './common';

/* --------------------------- FooterElementTypes --------------------------- */

export enum FooterElementType {
    Links = 'links',
    Text = 'text',
}

/* ------------------------------- TopPadding ------------------------------- */

export enum TopPadding {
    None = 'none',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

/* ---------------------------- HorizontalPadding --------------------------- */

export enum HorizontalPadding {
    None = 'none',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

/* ---------------------------- BaseFooterElement --------------------------- */

export const BaseFooterElement = object({
    id: string(),
    alignment: nativeEnum(Alignment),
    horizontalPadding: nativeEnum(HorizontalPadding),
    topPadding: nativeEnum(TopPadding),
    type: nativeEnum(FooterElementType),
});
export type BaseFooterElement = TypeOf<typeof BaseFooterElement>;

/* ---------------------------- FooterTextElement --------------------------- */

export const FooterTextElement = BaseFooterElement.extend({
    text: string(),
    type: literal(FooterElementType.Text),
});
export type FooterTextElement = TypeOf<typeof FooterTextElement>;

/* --------------------------- FooterLinksElement --------------------------- */

export const FooterLinksElement = BaseFooterElement.extend({
    links: array(Link),
    type: literal(FooterElementType.Links),
});
export type FooterLinksElement = TypeOf<typeof FooterLinksElement>;

/* ------------------------------ FooterElement ----------------------------- */

export const FooterElement = union([FooterTextElement, FooterLinksElement]);
export type FooterElement = TypeOf<typeof FooterElement>;

/* --------------------------------- Footer --------------------------------- */

export const Footer = object({
    id: string(),
    name: string(),
    description: string().optional(),
    elements: array(FooterElement),
});
export type Footer = TypeOf<typeof Footer>;
